import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement, Fragment } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * WordPress dependencies
 */
import { isRTL } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import RangeMark from './mark';
import { MarksWrapper, Rail } from './styles/range-control-styles';
export default function RangeRail(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$marks = _ref.marks,
      marks = _ref$marks === void 0 ? false : _ref$marks,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      restProps = _objectWithoutProperties(_ref, ["disabled", "marks", "min", "max", "step", "value"]);

  return createElement(Fragment, null, createElement(Rail, _extends({
    disabled: disabled
  }, restProps)), marks && createElement(Marks, {
    disabled: disabled,
    marks: marks,
    min: min,
    max: max,
    step: step,
    value: value
  }));
}

function Marks(_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$marks = _ref2.marks,
      marks = _ref2$marks === void 0 ? false : _ref2$marks,
      _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? 0 : _ref2$min,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? 100 : _ref2$max,
      _ref2$step = _ref2.step,
      step = _ref2$step === void 0 ? 1 : _ref2$step,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? 0 : _ref2$value;
  var marksData = useMarks({
    marks: marks,
    min: min,
    max: max,
    step: step,
    value: value
  });
  return createElement(MarksWrapper, {
    "aria-hidden": "true",
    className: "components-range-control__marks"
  }, marksData.map(function (mark) {
    return createElement(RangeMark, _extends({}, mark, {
      key: mark.key,
      "aria-hidden": "true",
      disabled: disabled
    }));
  }));
}

function useMarks(_ref3) {
  var marks = _ref3.marks,
      _ref3$min = _ref3.min,
      min = _ref3$min === void 0 ? 0 : _ref3$min,
      _ref3$max = _ref3.max,
      max = _ref3$max === void 0 ? 100 : _ref3$max,
      _ref3$step = _ref3.step,
      step = _ref3$step === void 0 ? 1 : _ref3$step,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? 0 : _ref3$value;

  if (!marks) {
    return [];
  }

  var range = max - min;

  if (!Array.isArray(marks)) {
    marks = [];
    var count = 1 + Math.round(range / step);

    while (count > marks.push({
      value: step * marks.length + min
    })) {
      ;
    }
  }

  var placedMarks = [];
  marks.forEach(function (mark, index) {
    if (mark.value < min || mark.value > max) {
      return;
    }

    var key = "mark-".concat(index);
    var isFilled = mark.value <= value;
    var offset = "".concat((mark.value - min) / range * 100, "%");

    var offsetStyle = _defineProperty({}, isRTL() ? 'right' : 'left', offset);

    placedMarks.push(_objectSpread(_objectSpread({}, mark), {}, {
      isFilled: isFilled,
      key: key,
      style: offsetStyle
    }));
  });
  return placedMarks;
}
//# sourceMappingURL=rail.js.map